module.exports = __webpack_public_path__ + "static/media/redes02.9ad47630.svg";